/**
 * 신원 제공자 싱글턴(결정 #8). Google OAuth(PKCE) 기반. 앱 전역에서 공유하며,
 * UI/동기화는 core의 IdentityProvider 인터페이스로만 다룬다(결정 #10).
 *
 * 익명이 기본이고 Google 연결은 선택 — 본인 Drive appDataFolder 백업 용도다.
 */
import { GoogleIdentityProvider } from "../platform/identity/google-identity.js";

export const identity = new GoogleIdentityProvider();
